<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/maipo/almaviva-wines')">Almaviva Wines</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/maipo/concha-y-toto')">Concha y Toto</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/chile/maipo/don-melchor')">Don Melchor</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile show-mobile-select"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Maipo Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Maipo ospita due dei più famosi vini cileni; i vini a base Cabernet Don Melchor di Concha y Toro e Casa Real di Santa Rita. Questi vini dovrebbero essere in cima alla tua lista di degustazione (per non parlare della tua lista di investimenti), insieme all'onnipresente Vinedo Chadwick ovviamente. Con massicci picchi andini che si innalzano fino a 2.600 piedi. sul livello del mare, molti dei vigneti di Maipo sono piantati in quota. Le colate alluvionali, il sole costante unito a serate fresche creano il terreno fertile ideale per sontuosi vini rossi di amarene.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Maipo Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Maipo ist die Heimat von zwei der berühmtesten chilenischen Spitzenweine; die auf Cabernet basierenden Weine Don Melchor von Concha y Toro und Casa Real von Santa Rita. Diese Weine sollten ganz oben auf Ihrer Verkostungsliste stehen (ganz zu schweigen von Ihrer Investitionsliste), zusammen mit dem allgegenwärtigen Vinedo Chadwick natürlich. Mit gewaltigen Andengipfeln, die bis zu 2.600 Fuß in die Höhe ragen. Über dem Meeresspiegel liegen viele Weinberge von Maipo in großer Höhe. Schwemmlandströme, konstanter Sonnenschein gepaart mit kühlen Abenden bilden den idealen Nährboden für üppige Schwarzkirsch-Rotweine.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Maipo Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Maipo abrite deux des vins fins chiliens les plus célèbres; les vins à base de cabernet Don Melchor de Concha y Toro et Casa Real de Santa Rita. Ces vins devraient figurer en bonne place sur votre liste de dégustation (sans parler de votre liste d'investissement), avec l'omniprésent Vinedo Chadwick bien sûr. Avec des pics andins massifs s'élevant jusqu'à 2 600 pieds. au-dessus du niveau de la mer, de nombreux vignobles de Maipo sont plantés en altitude. Des coulées alluviales, un ensoleillement constant couplé à des soirées fraîches créent le terreau idéal pour de somptueux vins rouges de cerise noire.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Maipo Valley</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Maipo is home to two of the most famous Chilean fine wine; the Cabernet-based wines Concha y Toro’s Don Melchor and Santa Rita’s Casa Real. These wines should be high on your tasting list (not to mention your investment list), along with the ubiquitous Vinedo Chadwick of course. With massive Andean peaks soaring up 2,600ft. above sea level, many of Maipo’s vineyards are planted at altitude. Alluvial flows, constant sunshine coupled with cool evenings create the ideal breeding ground for sumptuous black cherry red wines.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Maipo",
        data () {
            return {
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Almaviva Wines', src: '/wine-guide/chile/maipo/almaviva-wines' },
                    { report: 'Concha y Toto', src: '/wine-guide/chile/maipo/concha-y-toto' },
                    { report: 'Don Melchor', src: '/wine-guide/chile/maipo/don-melchor' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Maipo Valley fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Discover the rich history and exceptional flavors of the Maipo wine region in Chile. Known for producing premium red wines, including Cabernet Sauvignon, Merlot, and Carmenere, Maipo offers a unique winemaking experience unlike any other. Explore the stunning vineyards and taste the remarkable wines that embody the essence of Chile\'s winemaking tradition with a visit to the Maipo wine region.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }
</style>
